<template>
  <div role="none">
    <img :src="staticMapSrc"
      :alt="$t('enabled-locations-map.map-showing-data-center-location')">
  </div>
</template>

<script>
export default {
  name: 'MapboxStatic',

  props: {
    selectedLocation: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
    mapboxConfig: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      dimensions: '400x350',
      zoom: 15,
    }
  },

  computed: {
    staticMapSrc() {
      const { longitude, latitude } = this.selectedLocation
      const url = encodeURIComponent(process.env.VUE_APP_RED_PIN)
      // const overlay = `pin-m-rocket+ff0000(${longitude},${latitude})`;
      const overlay = `url-${url}(${longitude},${latitude})`
      const config = `access_token=${this.mapboxConfig.mapboxToken}`
      return `https://api.mapbox.com/styles/v1/mapbox/light-v10/static/${overlay}/${longitude},${latitude},${this.zoom},0/${this.dimensions}?${config}`
    },
  },
}
</script>

<style scoped>
div {
  position: relative;
}
img {
  object-fit: fill;
  width: 100%;
  height: 100%;
}
a {
  background-color: var(--megaport-slate);
  color: var(--megaport-blue);
  position: absolute;
  padding: 1rem;
  bottom: 0;
  right: 0;
}
</style>
